import { createQueryKeys } from '@lukemorales/query-key-factory';
import { useQuery } from '@tanstack/vue-query';
import { MaybeRefOrGetter } from '@vueuse/core';
import { hoursToMilliseconds, millisecondsToSeconds } from 'date-fns';

import { fetchFaceMatchesConfig } from '../services/facial-biometrics';
import { FACE_MATCH_DEFAULT_INTERVAL, FACE_MATCH_DEFAULT_MAX_ATTEMPTS } from '../constants/facialBiometrics';

export const facialBiometricQueryKeys = createQueryKeys('facial-biometrics', {
  faceMatchesConfig: (requirementKey: MaybeRefOrGetter<string>) => ['face-matches-config', { requirementKey }],
});

export function useFetchFaceMatchesConfig(signatureRequestKey: MaybeRefOrGetter<string>) {
  const result = useQuery({
    queryKey: facialBiometricQueryKeys.faceMatchesConfig(signatureRequestKey).queryKey,
    queryFn: () => fetchFaceMatchesConfig(toValue(signatureRequestKey)),
    staleTime: hoursToMilliseconds(24),
    refetchOnWindowFocus: false,
    initialDataUpdatedAt: 0,
    initialData: () => ({
      asyncChecking: {
        quantity: FACE_MATCH_DEFAULT_MAX_ATTEMPTS,
        intervalInSeconds: millisecondsToSeconds(FACE_MATCH_DEFAULT_INTERVAL),
      },
    }),
  });

  return {
    ...result,
    faceMatchesConfig: result.data,
  };
}
